
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homeyvIpzhrzPTz3UWRnXRfgips8338YeLa34cPVpwklmJYMeta } from "/app/polystore/client/pages/home.vue?macro=true";
import { default as indexo9KoqDvGEXNbmMFS49VL_77uMK0tB0pNykLcapSO23oMeta } from "/app/polystore/client/pages/index.vue?macro=true";
import { default as legalIgWtSvS_45QnEHB_454V1VGibMJ1YMyjGeuqgq261ov9WG0Meta } from "/app/polystore/client/pages/legal.vue?macro=true";
import { default as login_45kgEA_iEN2uGBpenyefrqH_45Si74Y_45I4QPQtE_45ACxQ_45sMeta } from "/app/polystore/client/pages/login.vue?macro=true";
import { default as signupFb9uQSUKWSu5YJebAdl7GCXfuP6pohubwkpcU2YF7ZgMeta } from "/app/polystore/client/pages/signup.vue?macro=true";
import { default as verify10cDMg09l_xgwXSlYSDCEsOQSgbYWz9tfASkQZ3_45adoMeta } from "/app/polystore/client/pages/verify.vue?macro=true";
import { default as archivePzimXL7RBXmaTdAzBKyWWmma_juWSXOsiCF7Eadu2bAMeta } from "/app/polystore/client/pages/archive.vue?macro=true";
import { default as settingsFoQ_jcowJ1du4m1bRZLOmmPIO7zi_tD7WxVSlI6BSvMMeta } from "/app/polystore/client/pages/settings.vue?macro=true";
import { default as onboardingUkFZ1OdXQ_45aYEJ7GD34ZiDElnr3bBhXC37qGLbwVwPAMeta } from "/app/polystore/client/pages/onboarding.vue?macro=true";
import { default as watch_45demowQ4asHDCNqi87Q_ZVSyemsGnLBi7q85mrUucbigJUIcMeta } from "/app/polystore/client/pages/watch-demo.vue?macro=true";
import { default as join_45discord7s87nq5iipmhWGVBPigbfOtllAQFAfy7VWd_45sJ0_45TdoMeta } from "/app/polystore/client/pages/join-discord.vue?macro=true";
import { default as texturesnsnZu61SKUoZsUXhftmpVqrP0a9Bbnq_CIP_45rlu_45U2EMeta } from "/app/polystore/client/pages/browse/textures.vue?macro=true";
import { default as change_45passwordImnDeX30l_45fFTH4cynRy_lMDll4NQ_Cv1Y4l70GfIo8Meta } from "/app/polystore/client/pages/change-password.vue?macro=true";
import { default as forgot_45passwordnrnkzVRjCr5zUXkCakWVSP6kY0kz_45mMMXW7LI9xwxM8Meta } from "/app/polystore/client/pages/forgot-password.vue?macro=true";
import { default as _91handle_93rVU7naLQBWBz1bhjUAgO9ufZp2rj_N_mBuq5Q5YcgNcMeta } from "/app/polystore/client/pages/shared/[handle].vue?macro=true";
import { default as newFRL8WvhOGCKvQ1E4kYfr7Kqejdr3vp5BEtZEInUShMgMeta } from "/app/polystore/client/pages/conversation/new.vue?macro=true";
import { default as _91shortId_9396eX7_brx_TiuC59F4fTrFOqb1NA1z7kS3_45WAR2d70EMeta } from "/app/polystore/client/pages/file/id/[shortId].vue?macro=true";
import { default as _91shortId_93Ll485z728Udy53TJ64ehVQQlAmDPyjMoaMLtu9W0HTkMeta } from "/app/polystore/client/pages/folder/id/[shortId].vue?macro=true";
import { default as _91shortId_934YIk47HZsLHFyg_45N9gBq_3W0cQqqh7fhrNGaUHokOrEMeta } from "/app/polystore/client/pages/search/id/[shortId].vue?macro=true";
import { default as traywbx_a_yPGOjqgRG1SQ5xqusnEDjqJRXLvaihsdxw2CMMeta } from "/app/polystore/client/pages/desktop-utilities/tray.vue?macro=true";
import { default as _91shortId_93WqO6M0ukRo7KODfEhoUTaI5oKLQdjxtXqDmDaHOgw2MMeta } from "/app/polystore/client/pages/conversation/id/[shortId].vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    component: () => import("/app/polystore/client/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexo9KoqDvGEXNbmMFS49VL_77uMK0tB0pNykLcapSO23oMeta || {},
    component: () => import("/app/polystore/client/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: legalIgWtSvS_45QnEHB_454V1VGibMJ1YMyjGeuqgq261ov9WG0Meta || {},
    component: () => import("/app/polystore/client/pages/legal.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login_45kgEA_iEN2uGBpenyefrqH_45Si74Y_45I4QPQtE_45ACxQ_45sMeta || {},
    component: () => import("/app/polystore/client/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupFb9uQSUKWSu5YJebAdl7GCXfuP6pohubwkpcU2YF7ZgMeta || {},
    component: () => import("/app/polystore/client/pages/signup.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verify10cDMg09l_xgwXSlYSDCEsOQSgbYWz9tfASkQZ3_45adoMeta || {},
    component: () => import("/app/polystore/client/pages/verify.vue")
  },
  {
    name: "archive",
    path: "/archive",
    component: () => import("/app/polystore/client/pages/archive.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/polystore/client/pages/settings.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingUkFZ1OdXQ_45aYEJ7GD34ZiDElnr3bBhXC37qGLbwVwPAMeta || {},
    component: () => import("/app/polystore/client/pages/onboarding.vue")
  },
  {
    name: "watch-demo",
    path: "/watch-demo",
    component: () => import("/app/polystore/client/pages/watch-demo.vue")
  },
  {
    name: "join-discord",
    path: "/join-discord",
    component: () => import("/app/polystore/client/pages/join-discord.vue")
  },
  {
    name: "browse-textures",
    path: "/browse/textures",
    component: () => import("/app/polystore/client/pages/browse/textures.vue")
  },
  {
    name: "change-password",
    path: "/change-password",
    meta: change_45passwordImnDeX30l_45fFTH4cynRy_lMDll4NQ_Cv1Y4l70GfIo8Meta || {},
    component: () => import("/app/polystore/client/pages/change-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordnrnkzVRjCr5zUXkCakWVSP6kY0kz_45mMMXW7LI9xwxM8Meta || {},
    component: () => import("/app/polystore/client/pages/forgot-password.vue")
  },
  {
    name: "shared-handle",
    path: "/shared/:handle()",
    component: () => import("/app/polystore/client/pages/shared/[handle].vue")
  },
  {
    name: "conversation-new",
    path: "/conversation/new",
    component: () => import("/app/polystore/client/pages/conversation/new.vue")
  },
  {
    name: "file-id-shortId",
    path: "/file/id/:shortId()",
    component: () => import("/app/polystore/client/pages/file/id/[shortId].vue")
  },
  {
    name: "folder-id-shortId",
    path: "/folder/id/:shortId()",
    component: () => import("/app/polystore/client/pages/folder/id/[shortId].vue")
  },
  {
    name: "search-id-shortId",
    path: "/search/id/:shortId()",
    component: () => import("/app/polystore/client/pages/search/id/[shortId].vue")
  },
  {
    name: "desktop-utilities-tray",
    path: "/desktop-utilities/tray",
    meta: traywbx_a_yPGOjqgRG1SQ5xqusnEDjqJRXLvaihsdxw2CMMeta || {},
    component: () => import("/app/polystore/client/pages/desktop-utilities/tray.vue")
  },
  {
    name: "conversation-id-shortId",
    path: "/conversation/id/:shortId()",
    component: () => import("/app/polystore/client/pages/conversation/id/[shortId].vue")
  }
]